import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { getConsent, setConsent } from '@/lib/consent';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the banner only if the visitor has not decided yet.
    if (!getConsent()) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Records consent AND triggers analytics to load (see src/lib/analytics.tsx).
    setConsent('accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    // No analytics load; the choice is remembered so the banner stays hidden.
    setConsent('declined');
    setIsVisible(false);
  };

  const handleClose = () => {
    // Closing without choosing is treated as declining (no consent given).
    setConsent('declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-wl-navy/95 backdrop-blur-md border-t border-white/20 p-4 z-50 animate-slide-up">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="text-white/90 text-sm flex-grow">
          <span>This website uses cookies to ensure you get the best experience. </span>
          <a href="/privacy" className="text-wl-green hover:underline">Learn more</a>
        </div>
        <div className="flex gap-3 items-center">
          <button 
            onClick={handleDecline}
            className="bg-white/10 hover:bg-white/20 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          >
            Decline
          </button>
          <button 
            onClick={handleAccept}
            className="bg-wl-green hover:bg-wl-green/90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors"
          >
            Accept All
          </button>
          <button 
            onClick={handleClose}
            className="text-white/60 hover:text-white/80 p-1 rounded transition-colors"
            aria-label="Close cookie banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
} 